export const allSeeds = {
  summerSeeds: [
    {
      id: "strawberry",
      name: "Strawberry",
      rarity: [
        { type: "Common", biopoints: 1, growTime: 120 },
        { type: "Uncommon", biopoints: 2, growTime: 120 },
        { type: "Rare", biopoints: 3, growTime: 120 },
        { type: "Epic", biopoints: 7, growTime: 120 },
        { type: "Legendary", biopoints: 13, growTime: 120 }
      ]
    },
    {
      id: "peas",
      name: "Peas",
      rarity: [
        { type: "Common", biopoints: 2, growTime: 240 },
        { type: "Uncommon", biopoints: 5, growTime: 240 },
        { type: "Rare", biopoints: 11, growTime: 240 },
        { type: "Epic", biopoints: 20, growTime: 240 },
        { type: "Legendary", biopoints: 40, growTime: 240 }
      ]
    },
    {
      id: "corn",
      name: "Corn",
      rarity: [
        { type: "Common", biopoints: 3, growTime: 360 },
        { type: "Uncommon", biopoints: 5, growTime: 360 },
        { type: "Rare", biopoints: 9, growTime: 360 },
        { type: "Epic", biopoints: 19, growTime: 360 },
        { type: "Legendary", biopoints: 41, growTime: 360 }
      ]
    },
    {
      id: "eggplant",
      name: "Eggplant",
      rarity: [
        { type: "Common", biopoints: 8, growTime: 1020 },
        { type: "Uncommon", biopoints: 18, growTime: 1020 },
        { type: "Rare", biopoints: 30, growTime: 1020 },
        { type: "Epic", biopoints: 61, growTime: 1020 },
        { type: "Legendary", biopoints: 129, growTime: 1020 }
      ]
    },
    {
      id: "watermelon",
      name: "Watermelon",
      rarity: [
        { type: "Common", biopoints: 51, growTime: 6720 },
        { type: "Uncommon", biopoints: 100, growTime: 6720 },
        { type: "Rare", biopoints: 196, growTime: 6720 },
        { type: "Epic", biopoints: 412, growTime: 6720 },
        { type: "Legendary", biopoints: 825, growTime: 6720 }
      ]
    },
    {
      id: "cucumber",
      name: "Cucumber",
      rarity: [
        { type: "Common", biopoints: 11, growTime: 900 },
        { type: "Uncommon", biopoints: 16, growTime: 840 },
        { type: "Rare", biopoints: 32, growTime: 780 },
        { type: "Epic", biopoints: 65, growTime: 720 },
        { type: "Legendary", biopoints: 107, growTime: 600 }
      ]
    },
    {
      id: "mint",
      name: "Mint",
      rarity: [
        { type: "Common", biopoints: 30, growTime: 3600 },
        { type: "Uncommon", biopoints: 74, growTime: 3300 },
        { type: "Rare", biopoints: 140, growTime: 3000 },
        { type: "Epic", biopoints: 250, growTime: 2400 },
        { type: "Legendary", biopoints: 360, growTime: 1800 }
      ]
    },
    {
      id: "blueberry",
      name: "Blueberry",
      rarity: [
        { type: "Common", biopoints: 47, growTime: 5400 },
        { type: "Uncommon", biopoints: 83, growTime: 5100 },
        { type: "Rare", biopoints: 250, growTime: 4800 },
        { type: "Epic", biopoints: 475, growTime: 4200 },
        { type: "Legendary", biopoints: 827, growTime: 3600 }
      ]
    },
    {
      id: "purple_carrot",
      name: "Purple Carrot",
      rarity: [
        { type: "Common", biopoints: 95, growTime: 10800 },
        { type: "Uncommon", biopoints: 156, growTime: 9000 },
        { type: "Rare", biopoints: 280, growTime: 8400 },
        { type: "Epic", biopoints: 940, growTime: 7800 },
        { type: "Legendary", biopoints: 1733, growTime: 7200 }
      ]
    },
    {
      id: "melon",
      name: "Melon",
      rarity: [
        { type: "Common", biopoints: 170, growTime: 18000 },
        { type: "Uncommon", biopoints: 320, growTime: 17400 },
        { type: "Rare", biopoints: 660, growTime: 16800 },
        { type: "Epic", biopoints: 1200, growTime: 15600 },
        { type: "Legendary", biopoints: 3600, growTime: 14400 }
      ]
    },{
      id: "pineapple",
      name: "Pineapple",
      rarity: [
        { type: "Common", biopoints: 250, growTime: 25200 },
        { type: "Uncommon", biopoints: 500, growTime: 23400 },
        { type: "Rare", biopoints: 1000, growTime: 21600 },
        { type: "Epic", biopoints: 2000, growTime: 19800 },
        { type: "Legendary", biopoints: 4510, growTime: 18000 }
      ]
    },
  ],
  
  springSeeds: [
    {
      id: "white_lily",
      name: "White Lily",
      rarity: [
        { type: "Common", biopoints: 190, growTime: 18000 },
        { type: "Uncommon", biopoints: 400, growTime: 18000 },
        { type: "Rare", biopoints: 970, growTime: 18000 },
        { type: "Epic", biopoints: 2170, growTime: 18000 },
        { type: "Legendary", biopoints: 4595, growTime: 18000 }
      ]
    },
    {
      id: "radish",
      name: "Radish",
      rarity: [
        { type: "Common", biopoints: 4, growTime: 480 },
        { type: "Uncommon", biopoints: 8, growTime: 480 },
        { type: "Rare", biopoints: 15, growTime: 480 },
        { type: "Epic", biopoints: 30, growTime: 480 },
        { type: "Legendary", biopoints: 57, growTime: 480 }
      ]
    },
    {
      id: "broccoli",
      name: "Broccoli",
      rarity: [
        { type: "Common", biopoints: 142, growTime: 19680 },
        { type: "Uncommon", biopoints: 280, growTime: 19680 },
        { type: "Rare", biopoints: 569, growTime: 19680 },
        { type: "Epic", biopoints: 1137, growTime: 19680 },
        { type: "Legendary", biopoints: 2282, growTime: 19680 }
      ]
    },
    {
      id: "cabbage",
      name: "Cabbage",
      rarity: [
        { type: "Common", biopoints: 6, growTime: 780 },
        { type: "Uncommon", biopoints: 12, growTime: 780 },
        { type: "Rare", biopoints: 21, growTime: 780 },
        { type: "Epic", biopoints: 42, growTime: 780 },
        { type: "Legendary", biopoints: 85, growTime: 780 }
      ]
    },
    {
      id: "cauliflower",
      name: "Cauliflower",
      rarity: [
        { type: "Common", biopoints: 15, growTime: 1920 },
        { type: "Uncommon", biopoints: 27, growTime: 1920 },
        { type: "Rare", biopoints: 61, growTime: 1920 },
        { type: "Epic", biopoints: 113, growTime: 1920 },
        { type: "Legendary", biopoints: 219, growTime: 1920 }
      ]
    },
    {
      id: "onion",
      name: "Onion",
      rarity: [
        { type: "Common", biopoints: 7, growTime: 900 },
        { type: "Uncommon", biopoints: 13, growTime: 900 },
        { type: "Rare", biopoints: 26, growTime: 900 },
        { type: "Epic", biopoints: 52, growTime: 900 },
        { type: "Legendary", biopoints: 108, growTime: 900 }
      ]
    },
    {
      id: "bell_pepper",
      name: "Bell Pepper",
      rarity: [
        { type: "Common", biopoints: 29, growTime: 3780 },
        { type: "Uncommon", biopoints: 58, growTime: 3780 },
        { type: "Rare", biopoints: 119, growTime: 3780 },
        { type: "Epic", biopoints: 234, growTime: 3780 },
        { type: "Legendary", biopoints: 335, growTime: 3780 }
      ]
    },
    {
      id: "chili_pepper",
      name: "Chili Pepper",
      rarity: [
        { type: "Common", biopoints: 81, growTime: 10860 },
        { type: "Uncommon", biopoints: 159, growTime: 10860 },
        { type: "Rare", biopoints: 320, growTime: 10860 },
        { type: "Epic", biopoints: 637, growTime: 10860 },
        { type: "Legendary", biopoints: 1285, growTime: 10860 }
      ]
    },
    {
      id: "sweet_potato",
      name: "Sweet Potato",
      rarity: [
        { type: "Common", biopoints: 107, growTime: 14640 },
        { type: "Uncommon", biopoints: 215, growTime: 14640 },
        { type: "Rare", biopoints: 422, growTime: 14640 },
        { type: "Epic", biopoints: 847, growTime: 14640 },
        { type: "Legendary", biopoints: 1701, growTime: 14640 }
      ]
    },
    {
      id: "garlic",
      name: "Garlic",
      rarity: [
        { type: "Common", biopoints: 36, growTime: 4680 },
        { type: "Uncommon", biopoints: 59, growTime: 4680 },
        { type: "Rare", biopoints: 117, growTime: 4680 },
        { type: "Epic", biopoints: 232, growTime: 4680 },
        { type: "Legendary", biopoints: 405, growTime: 4680 }
      ]
    },
    {
      id: "ginger",
      name: "Ginger",
      rarity: [
        { type: "Common", biopoints: 198, growTime: 28140 },
        { type: "Uncommon", biopoints: 402, growTime: 28140 },
        { type: "Rare", biopoints: 793, growTime: 28140 },
        { type: "Epic", biopoints: 1587, growTime: 28140 },
        { type: "Legendary", biopoints: 3161, growTime: 28140 }
      ]
    },
    {
      id: "snowdrop",
      name: "Snowdrop",
      rarity: [
        { type: "Common", biopoints: 70, growTime: 9360 },
        { type: "Uncommon", biopoints: 141, growTime: 9360 },
        { type: "Rare", biopoints: 276, growTime: 9360 },
        { type: "Epic", biopoints: 560, growTime: 9360 },
        { type: "Legendary", biopoints: 1116, growTime: 9360 }
      ]
    },
    {
      id: "mangold",
      name: "Mangold",
      rarity: [
        { type: "Common", biopoints: 41, growTime: 5400 },
        { type: "Uncommon", biopoints: 80, growTime: 5400 },
        { type: "Rare", biopoints: 163, growTime: 5400 },
        { type: "Epic", biopoints: 325, growTime: 5400 },
        { type: "Legendary", biopoints: 646, growTime: 5400 }
      ]
    },
    {
      id: "leek",
      name: "Leek",
      rarity: [
        { type: "Common", biopoints: 21, growTime: 2700 },
        { type: "Uncommon", biopoints: 43, growTime: 2700 },
        { type: "Rare", biopoints: 82, growTime: 2700 },
        { type: "Epic", biopoints: 165, growTime: 2700 },
        { type: "Legendary", biopoints: 337, growTime: 2700 }
      ]
    },
    {
      id: "spinach",
      name: "Spinach",
      rarity: [
        { type: "Common", biopoints: 11, growTime: 1380 },
        { type: "Uncommon", biopoints: 22, growTime: 1380 },
        { type: "Rare", biopoints: 46, growTime: 1380 },
        { type: "Epic", biopoints: 89, growTime: 1380 },
        { type: "Legendary", biopoints: 179, growTime: 1380 }
      ]
    },
    {
      id: "daikon",
      name: "Daikon",
      rarity: [
        { type: "Common", biopoints: 95, growTime: 12900 },
        { type: "Uncommon", biopoints: 189, growTime: 12900 },
        { type: "Rare", biopoints: 376, growTime: 12900 },
        { type: "Epic", biopoints: 759, growTime: 12900 },
        { type: "Legendary", biopoints: 1532, growTime: 12900 }
      ]
    }
  ],
  
  limitedSeeds: [
    {
      id: "black_lotus",
      name: "Black Lotus",
      rarity: [
        { type: "Common", biopoints: 400, growTime: 43200 },
        { type: "Uncommon", biopoints: 900, growTime: 43200 },
        { type: "Rare", biopoints: 2100, growTime: 43200 },
        { type: "Epic", biopoints: 4800, growTime: 43200 },
        { type: "Legendary", biopoints: 10050, growTime: 43200 }
      ]
    },
    {
      id: "sunflower",
      name: "Sunflower",
      rarity: [
        { type: "Common", biopoints: 32, growTime: 3600 },
        { type: "Uncommon", biopoints: 70, growTime: 3600 },
        { type: "Rare", biopoints: 166, growTime: 3600 },
        { type: "Epic", biopoints: 376, growTime: 3600 },
        { type: "Legendary", biopoints: 874, growTime: 3600 }
      ]
    },
    {
      id: "holly",
      name: "Holly",
      rarity: [
        { type: "Common", biopoints: 91, growTime: 10800 },
        { type: "Uncommon", biopoints: 180, growTime: 10800 },
        { type: "Rare", biopoints: 369, growTime: 10800 },
        { type: "Epic", biopoints: 701, growTime: 10800 },
        { type: "Legendary", biopoints: 1402, growTime: 10800 }
      ]
    },
    {
      id: "jack_pumpkin",
      name: "Jack Pumpkin",
      rarity: [
        { type: "Common", biopoints: 750, growTime: 86400 },
        { type: "Uncommon", biopoints: 1450, growTime: 72000 },
        { type: "Rare", biopoints: 3060, growTime: 57600 },
        { type: "Epic", biopoints: 5210, growTime: 43200 },
        { type: "Legendary", biopoints: 7360, growTime: 28800 }
      ]
    },
    {
      id: "patisson",
      name: "Patisson",
      rarity: [
        { type: "Common", biopoints: 24, growTime: 14400 },
        { type: "Uncommon", biopoints: 115, growTime: 13800 },
        { type: "Rare", biopoints: 528, growTime: 13200 },
        { type: "Epic", biopoints: 1575, growTime: 12600 },
        { type: "Legendary", biopoints: 3090, growTime: 12000 }
      ]
    }
  ]
};

// Function to convert seconds to hours and minutes format
const formatGrowTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${hours}h ${minutes}m`;
};

// Function to calculate biopoints per minute for a seed
export function calculateBpPerMinute(seed, rarity) {
  if (!seed) return 0;
  
  // If seed has direct biopoints and growTime (for flattened seeds)
  if (seed.biopoints && seed.growTime) {
    const growTimeMinutes = seed.growTime / 60; // Convert seconds to minutes
    return growTimeMinutes > 0 ? seed.biopoints / growTimeMinutes : 0;
  }
  
  // For seed data with rarity array
  if (seed.rarity && Array.isArray(seed.rarity)) {
    const rarityData = seed.rarity.find(r => 
      r.type.toLowerCase() === (rarity?.toLowerCase() || '')
    );
    
    if (rarityData) {
      const bp = rarityData.biopoints || 0;
      const growTimeMinutes = (rarityData.growTime || 1) / 60; // Convert seconds to minutes
      return growTimeMinutes > 0 ? bp / growTimeMinutes : 0;
    }
  }
  
  // Fallback for any other cases
  return 0;
}

export { formatGrowTime };
